<nz-modal
  [(nzVisible)]="isShowRegistration"
  nzCentered
  (nzOnCancel)="handleCancel()"
  (nzOnOk)="handleOk()"
  nzWrapClassName="login-modal"
  nzWidth="600px"
  nzMaskClosable="false"
  nzKeyboard="false"
  >
  <ng-container *nzModalContent>
    @if (!showTerms && !thankModal) {
      <div class="content-holder">
        <!-- Manual sign up -->
        @if (!isSocialSignUp) {
          <h1 class="modal-header">Create your account</h1>
          <p>
            Create your {{ siteData.siteName }} Careers account and we will help
            you find your dream career.
          </p>
          <div class="social-login">
            @if (siteData.registrationModal.socials.google) {
              <asl-google-signin-button class="google"
                type="standard"
                shape="pill"
                theme="outline"
                text="signup_with"
                size="large"
                logo_alignment="center"
                [width]="socialBtnWidth"
               />
            }
            @if (siteData.registrationModal.socials.facebook) {
              <a
                (click)="facebookSignUp()"
                >
                <img src="assets/images/facebook.png" alt="facebook" />
                <span>Sign up with Facebook</span>
              </a>
            }
            <!-- <a (click)="microsoftSignUp()">
            <img src="assets/images/microsoft.jpg" alt="microsoft" />
            <span>Sign up with Microsoft</span>
          </a> -->
          <!-- <button (click)="linkedInSignUp()">LinkedIn</button> -->
        </div>
        <div class="login-divider">
          <span>or</span>
        </div>
      }
      <!-- Social sign up -->
      @if (isSocialSignUp) {
        <h1 class="modal-header">
          Sign up with
          @if (registrationForm.value.googleId) {
            <span>Google</span>
          }
          @if (registrationForm.value.facebookId) {
            <span>Facebook</span>
          }
          @if (registrationForm.value.microsoftId) {
            <span>Microsoft</span>
          }
        </h1>
        <p>Complete your basic details.</p>
      }
      <ng-container [formGroup]="registrationForm">
        @if (!isSocialSignUp) {
          <div
            class="nz-block-input"
					[ngClass]="
						registrationForm.controls['firstName'].status === 'INVALID' &&
						registrationForm.controls['firstName'].touched
							? 'error'
							: ''
					"
            >
            <label>First name</label>
            <input
              nz-input
              placeholder="First name"
              formControlName="firstName"
              nzSize="large"
              (blur)="onBlur('firstName')"
              />
            </div>
          }
          @if (!isSocialSignUp) {
            <div
              class="nz-block-input"
					[ngClass]="
						registrationForm.controls['lastName'].status === 'INVALID' &&
						registrationForm.controls['lastName'].touched
							? 'error'
							: ''
					"
              >
              <label>Last name</label>
              <input
                nz-input
                formControlName="lastName"
                placeholder="Last name"
                nzSize="large"
                (blur)="onBlur('lastName')"
                />
              </div>
            }
            @if (!isSocialSignUp) {
              <div
                class="nz-block-input"
					[ngClass]="
						registrationForm.controls['friendlyName'].status === 'INVALID' &&
						registrationForm.controls['friendlyName'].touched
							? 'error'
							: ''
					"
                >
                <label>{{ siteData.registrationModal.labels.friendlyName }}</label>
                <input
                  nz-input
                  formControlName="friendlyName"
                  placeholder="What do you like to be called?"
                  nzSize="large"
                  (blur)="onBlur('friendlyName')"
                  />
                </div>
              }
              @if (!isSocialSignUp) {
                <div
                  class="nz-block-input"
					[ngClass]="
						registrationForm.controls['email'].status === 'INVALID' &&
						registrationForm.controls['email'].touched
							? 'error'
							: ''
					"
                  >
                  <label>Email address</label>
                  <input
                    nz-input
                    formControlName="email"
                    placeholder="Email address"
                    nzSize="large"
                    />
                  </div>
                }
                @if (isSocialSignUp) {
                  <mat-form-field class="block-input">
                    <input
                      matInput
                      type="text"
                      [(ngModel)]="registrationForm.value.email"
                      [disabled]="true"
                      [ngModelOptions]="{ standalone: true }"
                      />
                      <label
                        matSuffix
                        (click)="changeSocialSignUp()"
						style="
							margin-right: 15px;
							cursor: pointer;
							color: var(--color-blue);
						"
                        >
                        Change
                      </label>
                    </mat-form-field>
                  }
                  @if (isSocialSignUp) {
                    <div
                      class="nz-block-input"
					[ngClass]="
						registrationForm.controls['friendlyName'].status === 'INVALID' &&
						registrationForm.controls['friendlyName'].touched
							? 'error'
							: ''
					"
                      >
                      <label>{{ siteData.registrationModal.labels.friendlyName }}</label>
                      <input
                        nz-input
                        formControlName="friendlyName"
                        placeholder="What do you like to be called?"
                        nzSize="large"
                        />
                      </div>
                    }
                    <div
                      class="nz-block-input"
					[ngClass]="
						registrationForm.controls['country'].status === 'INVALID' &&
						registrationForm.controls['country'].touched
							? 'error'
							: ''
					"
                      >
                      <label>Country</label>
                      <nz-select
                        nzShowSearch
                        nzAllowClear
                        formControlName="country"
                        nzPlaceHolder="Country"
                        (ngModelChange)="onChangeCountry($event)"
                        >
                        @for (option of geoCountries; track option) {
                          <nz-option
                            nzCustomContent
                            [nzLabel]="option.name"
                            [nzValue]="option"
                            >
                            <img
                              [alt]="option.name"
                              [src]="'https://flagsapi.com/' + option.code + '/shiny/32.png'"
                              />&nbsp;&nbsp;{{ option.name }}
                            </nz-option>
                          }
                        </nz-select>
                      </div>
                      <div
                        class="nz-block-input"
					[ngClass]="{
						error:
							registrationForm.controls['stateProvice'].status === 'INVALID' &&
							registrationForm.controls['stateProvice'].touched
					}"
                        >
                        <label>State or province</label>
                        <nz-select
                          nzShowSearch
                          nzAllowClear
                          formControlName="stateProvice"
                          nzPlaceHolder="State or Province"
                          >
                          @for (option of geoProvinces; track option) {
                            <nz-option [nzLabel]="option.name"
                              [nzValue]="option.name"
                             />
                          }
                        </nz-select>
                      </div>
                      <div
                        class="nz-block-input"
					[ngClass]="{
						error:
							registrationForm.controls['phoneNumber'].status === 'INVALID' &&
							registrationForm.controls['phoneNumber'].touched
					}"
                        >
                        <label>Phone number</label>
                        <div nz-row [nzGutter]="8">
                          <div nz-col nzFlex="65px"  style="display: flex;">
                            <input
                              [disabled]="true"
                              nz-input
								style="
									width: 100%;
									border: 0px solid #fff !important;
									text-align: center;
								"
                              [(ngModel)]="registrationForm.value.countryCode"
                              placeholder="xxx"
                              [ngModelOptions]="{ standalone: true }"
                              />
                            </div>
                            <div nz-col nzFlex="auto">
                              <input
                                nz-input
                                placeholder="xxxxxxxx"
                                formControlName="phoneNumber"
                                nzSize="large"
                                />
                              </div>
                            </div>
                            <div class="hint">Country code based on the country selected.</div>
                          </div>
                          <div
                            class="nz-block-input"
					[ngClass]="{
						error:
							registrationForm.controls['sourceId'].status === 'INVALID' &&
							registrationForm.controls['sourceId'].touched
					}"
                            >
                            <label>Where did you hear about {{ siteData.siteName }}?</label>
                            <nz-select
                              formControlName="sourceId"
                              nzShowSearch
                              [nzAllowClear]="getSourceId ? false : true"
                              nzPlaceHolder="Select Source"
                              [nzDisabled]="getSourceId ? true : false"
                              >
                              @for (e of sources; track e) {
                                <nz-option [nzLabel]="e.option"
                                  [nzValue]="e.id"
                                 />
                              }
                            </nz-select>
                          </div>
                          @if (!isSocialSignUp) {
                            <div
                              class="nz-block-input"
					[ngClass]="{
						error:
							registrationForm.controls['password'].status === 'INVALID' &&
							registrationForm.controls['password'].touched
					}"
                              >
                              <label>Password</label>
                              <nz-input-group [nzSuffix]="suffixIconSearch">
                                <input
                                  nz-input
                                  formControlName="password"
                                  type="password"
                                  placeholder="Password"
                                  nzSize="large"
                                  [type]="showPassword ? 'text' : 'password'"
                                  />
                                </nz-input-group>
                                <ng-template #suffixIconSearch>
                                  <div (click)="showPassword = !showPassword">
                                    @if (showPassword) {
                                      <i class="fa-regular fa-eye"></i>
                                    }
                                    @if (!showPassword) {
                                      <i class="fa-regular fa-eye-slash"></i>
                                    }
                                  </div>
                                </ng-template>
                              </div>
                            }
                            @if (
                              !isSocialSignUp &&
                              registrationForm.controls['password'].status === 'INVALID' &&
                              registrationForm.controls['password'].touched
                              ) {
                              <div
                                class="error-holder"
					[ngClass]="{
						error:
							registrationForm.controls['password'].status === 'INVALID' &&
							registrationForm.controls['password'].touched
					}"
                                >
                                <h1>Password must contain:</h1>
                                <div
                                  class="message"
						[ngClass]="{
							error: registrationForm.value.password?.match('.{8,}')
						}"
                                  >
                                  <i class="fa-light fa-check"></i>
                                  <i class="fa-light fa-xmark"></i>
                                  At least 8 characters
                                </div>
                                <div
                                  class="message"
						[ngClass]="{
							error:
								registrationForm.value.password?.match('^(?=.*[A-Z])') &&
								registrationForm.value.password?.match('(?=.*[a-z])')
						}"
                                  >
                                  <i class="fa-light fa-check"></i>
                                  <i class="fa-light fa-xmark"></i>
                                  both lower (a-z) and upper case letters (A-Z)
                                </div>
                                <div
                                  class="message"
						[ngClass]="{
							error:
								registrationForm.value.password?.match('^(?=.*[0-9])') &&
								registrationForm.value.password?.match('(?=.*[!@#$%^&*])')
						}"
                                  >
                                  <i class="fa-light fa-check"></i>
                                  <i class="fa-light fa-xmark"></i>
                                  at least one number (0-9) and a symbol
                                </div>
                              </div>
                            }
                            <mat-checkbox
                              class="checkbox"
                              [(ngModel)]="isChecked"
                              [ngModelOptions]="{ standalone: true }"
                              >
                              I agree to the
                              <a routerLink="/terms-of-service" target="_blank"
                                ><span class="blue">Terms and Conditions</span></a
                                >
                                and have read and understood the
                                <a routerLink="/privacy-policy" target="_blank"
                                  ><span class="blue">Privacy Policy</span></a
                                  >.
                                </mat-checkbox>
                                <button
                                  nz-button
                                  class="btn-next new-registration-btn"
                                  nzType="primary"
                                  nzSize="large"
                                  nzShape="round"
                                  [disabled]="ClickedCreateAccount"
                                  (click)="saveNewAccount()"
                                  >
                                  {{ siteData.registrationModal.saveLabel }}
                                </button>
                                <div class="login-account">
                                  <span>Already have an account?</span>
                                  <a (click)="showLogin()">{{ siteData.signIn }}</a>
                                </div>
                              </ng-container>
                            </div>
                          }
                          @if (showTerms) {
                            <div class="content-terms">
                              <h1>DATA PRIVACY NOTICE</h1>
                              {{ siteData.siteName }} is committed to protecting the privacy of its data
                              subjects, and ensuring the safety and security of personal data under its
                              control and custody. This policy provides information on what personal
                              data is gathered by Cloudstaff Recruit about its current, past, and
                              prospective employees; how it will use and process this; how it will keep
                              this secure; and how it will dispose of it when it is no longer needed.
                              This information is provided in compliance with the Philippine Republic
                              Act No. 10173, also known as, the Data Privacy Act of 2012 (DPA) and its
                              Implementing Rules and Regulations (DPA-IRR), and other applicable data
                              privacy legislations. It sets out {{ siteData.siteName }}’ data protection
                              practices designed to safeguard the personal data of individuals it deals
                              with, and also to inform such individuals of their rights under the Act.
                              <br /><br />
                              The personal data obtained from this application is entered and stored
                              within the {{ siteData.siteName }} system and will only be accessed by the
                              {{ siteData.siteName }}’s authorized personnel.
                              {{ siteData.siteName }} have instituted appropriate organizational,
                              technical and physical security measures to ensure the protection of the
                              applicants personal data. <br /><br />
                              Furthermore, the information collected and stored in the application shall
                              only be used for the following purposes:
                              <br /><br />
                              <ul style="margin-left: 30px">
                                <li>Recruitment Processing</li>
                                <li>Background checking of potential candidates</li>
                                <li>
                                  Presentation to potential clients where the candidate profile may fit
                                  with the position required
                                </li>
                              </ul>
                              {{ siteData.siteName }} shall not disclose the applicants’ personal
                              information without their consent and shall retain this information over a
                              period of three (3) years as part of its potential talent pool.
                              <br /><br />
                              <h1>APPLICANT CONSENT</h1>
                              I have read the Data Privacy Statement and expressed my consent for
                              {{ siteData.siteName }} to collect, record, organize, update or modify,
                              retrieve, consult, use, consolidate, block, erase or destruct my personal
                              data as part of my information. <br /><br />
                              I hereby affirm my right to be informed, object to processing, access and
                              rectify, suspend or withdraw my personal data, and be indemnified in case
                              of damages pursuant to the provisions of the Republic Act No. 10173 of the
                              Philippines, Data Privacy Act of 2012 and its corresponding Implementing
                              Rules and Regulations, and other applicable data privacy legislations.
                              <br /><br />
                              If you want to exercise any of your rights, or if you have any questions
                              about how we process your personal data, please contact
                              {{ siteData.siteName }} Data Protection Officer, through the following
                              channel: <br /><br />
                              Email to
                              <a href="mailto:privacy@cloudstaff.co">privacy&#64;cloudstaff.com</a>
                              <br /><br />
                              Please note that if you request for your Jobs.Cloudstaff.com profile to be
                              deleted, the deletion of your profile does not affect the details already
                              forwarded to potential clients or downloaded by clients.
                              <br /><br />
                              <button
                                nz-button
                                class="btn-next"
                                nzType="primary"
                                (click)="showTerms = false"
                                nzSize="large"
                                nzShape="round"
                                >
                                I agree
                              </button>
                            </div>
                          }
                          @if (thankModal) {
                            <div class="content-thank-you">
                              @if (!isSocialSignUp) {
                                <img src="../../../assets/images/verify-account.png" alt="" />
                                @if (isNotVerified) {
                                  <h1 class="modal-header">
                                    You’re on your way to your new career at {{ siteData.siteName }}.
                                    Check your email to confirm your account.
                                  </h1>
                                  <p>
                                    Your account is still waiting for confirmation. Please check your
                                    email for the verification link or resend it.
                                  </p>
                                  <br />
                                  <button
                                    nz-button
                                    class="btn-next"
                                    nzType="primary"
                                    (click)="handleOk()"
                                    nzSize="large"
                                    nzShape="round"
                                    style="margin-right: 10px"
                                    >
                                    Done
                                  </button>
                                  <button
                                    nz-button
                                    class="btn-next"
                                    nzType="default"
                                    (click)="resendCode()"
                                    nzSize="large"
                                    nzShape="round"
                                    >
                                    Resend link
                                  </button>
                                } @else {
                                  <h1 class="modal-header">
                                    You’re on your way
                                    <span>to your new career at {{ siteData.siteName }}!</span>
                                  </h1>
                                  <p>
                                    Thanks for registering. We’ve sent you an email with some important
                                    information about your account. Please read the email and click the
                                    confirmation link to activate you account.
                                  </p>
                                  <p>
                                    Stay tuned for updates and notifications as we begin the process of
                                    helping you shape your professional path.
                                  </p>
                                  <button
                                    nz-button
                                    class="btn-next"
                                    nzType="primary"
                                    (click)="handleOk()"
                                    nzSize="large"
                                    nzShape="round"
                                    >
                                    Done
                                  </button>
                                  <div class="resend-code">
                                    <span>Didn’t get the email?</span>
                                    <a (click)="resendCode()">Click here to resend it.</a>
                                  </div>
                                }
                              }
                              @if (isSocialSignUp) {
                                @if (isNotVerified) {
                                  <img src="../../../assets/images/verify-account.png" alt="" />
                                  <h1 class="modal-header">
                                    You’re on your way to your new career at Cloudstaff. Check your email
                                    to confirm your account.
                                  </h1>
                                  <p>
                                    Your account is still waiting for confirmation. Please check your
                                    email for the verification link or resend it.
                                  </p>
                                  <br />
                                  <button
                                    nz-button
                                    class="btn-next"
                                    nzType="primary"
                                    (click)="handleOk()"
                                    nzSize="large"
                                    nzShape="round"
                                    style="margin-right: 10px"
                                    >
                                    Done
                                  </button>
                                  <button
                                    nz-button
                                    class="btn-next"
                                    nzType="default"
                                    (click)="resendCode()"
                                    nzSize="large"
                                    nzShape="round"
                                    >
                                    Resend link
                                  </button>
                                } @else {
                                  <img src="assets/images/sign-up-done.png" alt="sign-up-done" />
                                  <h1 class="modal-header">Start Searching</h1>
                                  <p>
                                    Thanks for signing up. You can start applying for careers and our team
                                    of expert recruiters will start looking for a career that is perfect
                                    for you.
                                  </p>
                                  <p>
                                    Stay tuned for updates and notifications as we begin the process of
                                    helping you shape your professional path.
                                  </p>
                                  <br /><br />
                                  <button
                                    nz-button
                                    class="btn-next"
                                    nzType="primary"
                                    (click)="redirectJoblist()"
                                    nzSize="large"
                                    nzShape="round"
                                    >
                                    Start Searching
                                  </button>
                                }
                              }
                            </div>
                          }
                        </ng-container>
                        <div *nzModalFooter></div>
                      </nz-modal>
